// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37oyR","clinicsSelect":"styles_clinicsSelect__2nt4b"};